// Bilingual copy for the whole app. Category "values" stay English (DB keys);
// only the displayed labels change per language.
export const translations = {
  en: {
    nav: { catalog: "Catalog", admin: "Admin" },
    hero: {
      subtitle: "The public archive of dishonor",
      titleLines: [
        [{ text: "Shame" }],
        [{ text: "of the " }, { text: "Country", hl: true }],
      ],
      description:
        "A categorized catalog of the people who bring dishonor upon the country — recorded, sorted and preserved.",
      metaArchive: "ARCHIVE // ACTIVE",
      metaRecord: "PUBLIC RECORD No. SR-2025",
    },
    stats: {
      total: "Total Cataloged",
      categories: "Categories",
      updated: "Last Updated",
      status: "Status",
      statusValue: "ACTIVE",
    },
    marquee: [
      "CATALOG OF SHAME",
      "TRUTH RECORDED",
      "UPDATED DAILY",
      "NO NAME FORGOTTEN",
      "PUBLIC ARCHIVE",
    ],
    manifesto: {
      label: "[ Manifesto ]",
      chapters: [
        {
          title: "We Record",
          body: "Every name entered here is documented, categorized and preserved. Memory is a form of resistance against the machinery of forgetting.",
        },
        {
          title: "We Categorize",
          body: "Artists, politicians, propagandists, officials. The archive sorts complicity into clear taxonomies so that patterns become visible.",
        },
        {
          title: "We Remain",
          body: "This catalog does not expire. What is written stays written. Accountability outlives the news cycle.",
        },
      ],
    },
    catalog: {
      label: "[ The Catalog ]",
      title: "Records",
      search: "SEARCH NAME",
      categoryPlaceholder: "Category",
      allCategories: "All Categories",
      loading: "Loading records...",
      empty: "No records found",
    },
    footer: { tagline: "Public Archive // {year} // Truth Recorded" },
    card: { sev: "SEV" },
    detail: {
      back: "Back to catalog",
      record: "Record",
      category: "Category",
      region: "Region",
      severity: "Severity",
      dateAdded: "Date Added",
      reason: "[ Reason for Record ]",
      noDescription: "No description recorded.",
      sources: "[ Sources ]",
      loading: "Loading record...",
    },
    admin: {
      controlRoom: "[ Control Room ]",
      dashboard: "Admin Dashboard",
      addRecord: "Add Record",
      logout: "Logout",
      thPhoto: "Photo",
      thName: "Name",
      thCategory: "Category",
      thRegion: "Region",
      thSev: "Sev",
      thActions: "Actions",
      noRecords: "No records yet",
      editRecord: "Edit Record",
      newRecord: "New Record",
      photo: "Photo",
      fullName: "Full Name *",
      category: "Category",
      severity: "Severity (1-5)",
      region: "Region",
      description: "Reason / Description",
      sources: "Sources (one URL per line)",
      upload: "Upload",
      saving: "Saving...",
      updateRecord: "Update Record",
      createRecord: "Create Record",
      toastImgLarge: "Image too large (max 2MB)",
      toastNameRequired: "Full name is required",
      toastUpdated: "Record updated",
      toastAdded: "Record added",
      toastSaveFailed: "Save failed",
      confirmDelete: 'Delete record "{name}"?',
      toastDeleted: "Record deleted",
      toastDeleteFailed: "Delete failed",
    },
    auth: {
      authenticating: "Authenticating...",
      verifying: "Verifying access...",
      restricted: "Restricted",
      accessLines: ["Admin", "Access"],
      gateDesc:
        "This control room is restricted to authorized archivists. Sign in with Google to manage records.",
      denied: "Access denied — this Google account is not on the authorized list.",
      continueGoogle: "Continue with Google",
    },
    categories: {
      Artists: "Artists",
      Politicians: "Politicians",
      Bloggers: "Bloggers",
      Military: "Military",
      Officials: "Officials",
      Propagandists: "Propagandists",
      Businessmen: "Businessmen",
      Celebrities: "Celebrities",
    },
  },

  ru: {
    nav: { catalog: "Каталог", admin: "Админ" },
    hero: {
      subtitle: "Публичный архив бесчестия",
      titleLines: [[{ text: "Позор" }], [{ text: "страны", hl: true }]],
      description:
        "Категоризированный каталог людей, которые позорят страну — задокументировано, отсортировано и сохранено.",
      metaArchive: "АРХИВ // АКТИВЕН",
      metaRecord: "ПУБЛИЧНАЯ ЗАПИСЬ № SR-2025",
    },
    stats: {
      total: "Всего в каталоге",
      categories: "Категории",
      updated: "Обновлено",
      status: "Статус",
      statusValue: "АКТИВЕН",
    },
    marquee: [
      "КАТАЛОГ ПОЗОРА",
      "ПРАВДА ЗАПИСАНА",
      "ОБНОВЛЯЕТСЯ ЕЖЕДНЕВНО",
      "НИ ОДНО ИМЯ НЕ ЗАБЫТО",
      "ОБЩЕСТВЕННЫЙ АРХИВ",
    ],
    manifesto: {
      label: "[ Манифест ]",
      chapters: [
        {
          title: "Мы фиксируем",
          body: "Каждое внесённое сюда имя задокументировано, категоризировано и сохранено. Память — это форма сопротивления машине забвения.",
        },
        {
          title: "Мы категоризируем",
          body: "Артисты, политики, пропагандисты, чиновники. Архив сортирует соучастие по чётким категориям, чтобы закономерности стали видимыми.",
        },
        {
          title: "Мы остаёмся",
          body: "Этот каталог не имеет срока давности. Что записано — остаётся записанным. Ответственность переживает новостной цикл.",
        },
      ],
    },
    catalog: {
      label: "[ Каталог ]",
      title: "Записи",
      search: "ПОИСК ПО ИМЕНИ",
      categoryPlaceholder: "Категория",
      allCategories: "Все категории",
      loading: "Загрузка записей...",
      empty: "Записи не найдены",
    },
    footer: { tagline: "Публичный архив // {year} // Правда записана" },
    card: { sev: "УР" },
    detail: {
      back: "Вернуться в каталог",
      record: "Запись",
      category: "Категория",
      region: "Регион",
      severity: "Уровень",
      dateAdded: "Дата добавления",
      reason: "[ Причина внесения ]",
      noDescription: "Описание не указано.",
      sources: "[ Источники ]",
      loading: "Загрузка записи...",
    },
    admin: {
      controlRoom: "[ Пункт управления ]",
      dashboard: "Панель администратора",
      addRecord: "Добавить запись",
      logout: "Выйти",
      thPhoto: "Фото",
      thName: "Имя",
      thCategory: "Категория",
      thRegion: "Регион",
      thSev: "Ур.",
      thActions: "Действия",
      noRecords: "Пока нет записей",
      editRecord: "Редактировать запись",
      newRecord: "Новая запись",
      photo: "Фото",
      fullName: "Полное имя *",
      category: "Категория",
      severity: "Уровень (1-5)",
      region: "Регион",
      description: "Причина / Описание",
      sources: "Источники (по одному URL на строку)",
      upload: "Загрузить",
      saving: "Сохранение...",
      updateRecord: "Обновить запись",
      createRecord: "Создать запись",
      toastImgLarge: "Изображение слишком большое (макс. 2МБ)",
      toastNameRequired: "Укажите полное имя",
      toastUpdated: "Запись обновлена",
      toastAdded: "Запись добавлена",
      toastSaveFailed: "Не удалось сохранить",
      confirmDelete: "Удалить запись «{name}»?",
      toastDeleted: "Запись удалена",
      toastDeleteFailed: "Не удалось удалить",
    },
    auth: {
      authenticating: "Аутентификация...",
      verifying: "Проверка доступа...",
      restricted: "Доступ ограничен",
      accessLines: ["Доступ", "администратора"],
      gateDesc:
        "Этот пункт управления доступен только авторизованным архивистам. Войдите через Google, чтобы управлять записями.",
      denied: "Доступ запрещён — этот аккаунт Google не в списке авторизованных.",
      continueGoogle: "Войти через Google",
    },
    categories: {
      Artists: "Артисты",
      Politicians: "Политики",
      Bloggers: "Блогеры",
      Military: "Военные",
      Officials: "Чиновники",
      Propagandists: "Пропагандисты",
      Businessmen: "Бизнесмены",
      Celebrities: "Знаменитости",
    },
  },
};
